import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registerAxiosInterceptors } from './utils/axios-interceptor';

/**
 * H2: 入口预加载
 * 在页面渲染前异步加载租户配置，并注册全局axios拦截器。
 * 渲染不等待预加载完成（非阻塞），配置在后台异步拉取。
 */
async function bootstrap() {
    // 注册全局 axios 拦截器（超时/重试/离线提示）
    registerAxiosInterceptors();

    // 立即渲染应用
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(<App />);
}

bootstrap();